import { StyleSheet } from '@react-pdf/renderer';

const pendingDemandaUsoInsumoReportStyles = StyleSheet.create({
  page: { padding: 30, fontSize: 9, paddingBottom: 50 },
  pageHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
    fontSize: 9,
    color: '#555',
  },
  headerSide: { flex: 1 },
  headerCenter: { flex: 2, textAlign: 'center', color: '#00796b' },
  reportTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 11,
    marginBottom: 3,
  },
  propertyName: { marginBottom: 2 },
  period: { marginBottom: 2 },
  generatedAt: { marginBottom: 10 },
  itemContainer: { marginBottom: 20 },
  table: { marginTop: 6 },
  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#000',
    paddingBottom: 4,
    marginBottom: 2,
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 3,
  },
  tableHeaderText: { fontFamily: 'Helvetica-Bold' },
  colProduto: { paddingRight: 6 },
  colQtdRecomendada: { textAlign: 'right', paddingLeft: 4 },
  colSaldoFisico: { textAlign: 'right', paddingLeft: 4 },
  colSaldoEmUso: { textAlign: 'right', paddingLeft: 4 },
  colSaldo: { textAlign: 'right', paddingLeft: 4 },
  colQtdReceber: { textAlign: 'right', paddingLeft: 4 },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 9,
    color: '#555',
  },
});

export default pendingDemandaUsoInsumoReportStyles;
